import { defineComponent, useTemplateRef, ref, shallowRef, watch, onUnmounted, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, createTextVNode, normalizeStyle, mergeProps } from 'vue';
import _sfc_main$1 from '../../../component/dialog/dialog.vue.js';
import '@ssml-editor/core';
import { Button, EditorUtils } from '@ssml-editor/vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import { SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
import { useElementBounding } from '../../../node_modules/.pnpm/@vueuse_core@14.2.1_vue@3.5.31_typescript@5.9.3_/node_modules/@vueuse/core/dist/index.js';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import { SpeakContentData } from './data.js';
import { SpeakMenuService } from './speak-menu-service.js';
import SpeakContent from './speak-content.js';
import '../voice/voice-menu.vue.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "speak-menu",
  props: {
    rates: {},
    pitches: {},
    effects: {},
    storedRecordCount: {},
    bgmPageSize: {},
    bgmCategoryPageSize: {},
    fetchBgms: { type: Function },
    fetchCategories: { type: Function },
    searchBgms: { type: Function },
    editor: {},
    config: {}
  },
  setup(__props) {
    const menuBarButtonRef = useTemplateRef("menu-bar-button");
    const dialogVisible = ref(false);
    const speakMenuService = shallowRef();
    const speakContentData = ref(new SpeakContentData());
    const { x, y, height } = useElementBounding(menuBarButtonRef);
    const margin = ref("");
    const props = __props;
    function show() {
      margin.value = `${y.value + height.value}px 0 0 ${x.value}px`;
      dialogVisible.value = true;
    }
    function hide() {
      dialogVisible.value = false;
    }
    function menuClickHandler() {
      const editor = props.editor;
      if (editor) {
        speakMenuService.value ??= new SpeakMenuService(editor);
        EditorUtils.trimSelection(editor);
        if (!speakMenuService.value.isDisabled()) {
          const data = speakMenuService.value.getNodeAsSpeakContentData();
          data && (speakContentData.value = data);
          show();
        }
      }
    }
    function submitHandler(data) {
      speakMenuService.value?.setNode(data);
      hide();
    }
    function ssmlMarkClickHandler(_eventName, _editor, element) {
      if (element.type === SPEAK_TYPE) {
        speakMenuService.value = void 0;
        menuClickHandler();
      }
    }
    watch(() => props.editor, (newValue, oldValue) => {
      oldValue?.off("ssml-mark-click", ssmlMarkClickHandler);
      newValue?.on("ssml-mark-click", ssmlMarkClickHandler);
    }, {
      immediate: true
    });
    onUnmounted(() => {
      props.editor?.off("ssml-mark-click", ssmlMarkClickHandler);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Button), {
          ref: "menu-bar-button",
          "icon-class": "iconfont-ssml-editor icon-ssml-editor-speaker",
          onClick: menuClickHandler
        }, {
          default: withCtx(() => [
            createTextVNode("属性")
          ]),
          _: 1
        }, 512),
        createVNode(unref(_sfc_main$1), {
          title: "属性",
          width: "calc(var(--el-dialog-padding-primary) * 2 + 43.75rem)",
          "destroy-on-close": true,
          "show-footer": false,
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": ($event) => dialogVisible.value = $event,
          style: normalizeStyle({ margin: margin.value })
        }, {
          default: withCtx(() => [
            createVNode(SpeakContent, mergeProps({
              modelValue: speakContentData.value,
              "onUpdate:modelValue": ($event) => speakContentData.value = $event
            }, props, { onSubmit: submitHandler }), null, 16, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "style"])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=speak-menu.vue.js.map
